import React from 'react';
import TravelImg1 from '../../imgs/travel.jpg';
import TravelImg2 from '../../imgs/homepage.jpg';

const TravelRetreats: React.FC = () => {
  return (
    <div className="min-h-screen bg-lighttan pt-28">
        <h1 className="text-4xl font-bold text-darkgreentext mb-12 text-center">
          Travel Retreats
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4">
            <img
            src={TravelImg1}
            alt="Travel Retreat"
            className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
            <img
            src={TravelImg2}
            alt="Travel Retreat"
            className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
        </div>

      <div className="max-w-4xl mx-auto px-8 py-16 text-center">
        <p className="text-xl text-darkgreentext leading-relaxed">
          Practicing the Wim Hof Method and a Motiv8 Lifestyle outside of your normal environment can be a great way to 
          kickstart your practice or just a good way to have a fresh reset.  The basic premise is to go to really cool 
          places, with really cool people, and do really cool things. Only cool people apply!!
        </p>
      </div>
      <div className="max-w-4xl mx-auto px-8 py-16 text-center">
        <p className="text-2xl font-bold text-darkgreentext leading-relaxed">
          Events to Come
        </p>
        <p className='text-xl text-darkgreentext leading-relaxed'>
          Ireland
        </p>
        <p className='text-xl text-darkgreentext leading-relaxed'>
          Island Park, ID
        </p>
        <p className='text-xl text-darkgreentext leading-relaxed'>
          China
        </p>
      </div>
    </div>
  );
};

export default TravelRetreats;
